<template>
  <d2-container>
    <el-button
      class="filter-item"
      v-permission:function="['loveDCounselor:btn_add']"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="cardData"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="封面图">
        <template slot-scope="scope">
          <img :src="scope.row.cover" alt style="width:80px;height:80px" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="介绍">
        <template slot-scope="scope">
          <span>{{ scope.row.introduce }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
             v-permission:function="['loveDCounselor:btn_edit']"
            style="margin-top: 10px;"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getFormList
} from '@/api/demo/loveCounselor/index'
export default {
  name: 'loveDCounselor',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      loveDCounselor_btn_add: false,
      loveDCounselor_btn_edit: false,

      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      cardData: [], // 表格数据
      total: null
    }
  },
  watch: {
    $route (to, from) {
      this.getSearch()
    }
  },
  created () {
    this.getSearch()
  },
  mounted () {},
  methods: {
    // 搜索条件
    getSearch (val) {
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getFormList(this.listQuery).then(res => {
        this.listLoading = true
        this.cardData = res.records
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    // 添加
    getAdd () {
      this.$router.push({
        path: '/demo/loveCounselor/addLoveCoun'
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/demo/loveCounselor/addLoveCoun?id=' + id
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    }
  }
}
</script>

<style scoped>
</style>
